import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAppSelector } from '../store'
import Loading from '../components/layouts/Loading'

const ProtectedRoute = () => {
  const location = useLocation()
  const { loading, isAuthenticated } = useAppSelector(state => state.user)
  const prePath = sessionStorage.getItem('return-to')
  if (loading) return <Loading />
  if (isAuthenticated) {
    return <Outlet />
  }
  return (
    <Navigate
      to={
        prePath !== null && prePath !== '' && prePath !== '/'
          ? prePath
          : '/login'
      }
      state={{ from: location }}
    />
  )
}

export default ProtectedRoute
